import { isTourDemoId } from "./tourDemoFixtures";
import { setPingfloTourRunning } from "./tourTarget";
import { LANDING_PATH_BY_ROLE } from "./tourIds";
import { PINGFLO_TOUR_CLEARED_EVENT } from "./tourEvents";

const SESSION_KEYS = ["rsessn", "sesinf", "grpinf"];
let tourExitUntil = 0;

export function isTourExitPending() {
  return Date.now() < tourExitUntil;
}

function looksLikeTourDemo(value) {
  if (value == null) return false;
  if (typeof value === "string") return isTourDemoId(value);
  if (typeof value !== "object") return false;
  try {
    const blob = JSON.stringify(value);
    if (blob.includes("tour-demo")) return true;
  } catch {
    /* ignore */
  }
  return (
    isTourDemoId(value.ts_id) ||
    isTourDemoId(value.gr_id) ||
    isTourDemoId(value.groupDetails?.gr_id)
  );
}

/** Drop fictitious hall data left in storage while Pingflo was walking. */
export function clearTourDemoStorage() {
  try {
    SESSION_KEYS.forEach((key) => {
      const raw = localStorage.getItem(key);
      if (!raw) return;
      try {
        if (looksLikeTourDemo(JSON.parse(raw))) localStorage.removeItem(key);
      } catch {
        if (String(raw).includes("tour-demo")) localStorage.removeItem(key);
      }
    });
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new Event("smarttt-session-changed"));
    window.dispatchEvent(new CustomEvent(PINGFLO_TOUR_CLEARED_EVENT));
  } catch {
    /* ignore */
  }
}

export function restoreRealClubAfterTour({ navigate, role, toProfile = false } = {}) {
  tourExitUntil = Date.now() + 1500;
  setPingfloTourRunning(false);
  clearTourDemoStorage();
  if (typeof navigate !== "function") return;
  if (toProfile) {
    navigate("/profile");
    return;
  }
  const landing = LANDING_PATH_BY_ROLE[role] || "/home";
  navigate(landing, { replace: true });
}
